import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';

/**
 * @component MenuTooltip
 * @param { Object } props
 * @param { string } props.title
 * @param { string } props.disabledTitle
 * @param { boolean } props.disabled
 * @param { function } props.onClick
 * @param { ReactElement } props.icon
 * @returns { JSX.Element }
 */
function MenuTooltip({ title, disabledTitle, disabled, onClick, icon }) {
	return (
		<Tooltip arrow title={disabled ? disabledTitle : title}>
			<span>
				<IconButton disabled={disabled} onClick={onClick}>
					{icon}
				</IconButton>
			</span>
		</Tooltip>
	);
}

export default MenuTooltip;
